import React from "react";
import { Widget } from "@typeform/embed-react";
import PropTypes from "prop-types";

import { Heading } from "style/components/Heading.styles";
import { IconClose } from "assets/icons";
import { TYPEFORM_ID } from "utils/constants";
import { HelpCenterSubCardContainer } from "../HelpCenter.styles";

const RequestFeatureTypeForm = ({ handleMenuClose }) => {
  return (
    <HelpCenterSubCardContainer>
      <div className="wrapper">
        <div className="header">
          <Heading className="pb-4">Request a Feature</Heading>
          <IconClose
            fill="#048AF5"
            className="close-icon"
            height={24}
            width={24}
            onClick={handleMenuClose}
          />
        </div>
        <div className="typeform-widget">
          <Widget id={TYPEFORM_ID} className="typeform" />
        </div>
      </div>
    </HelpCenterSubCardContainer>
  );
};

RequestFeatureTypeForm.propTypes = {
  handleMenuClose: PropTypes.func,
};

export { RequestFeatureTypeForm };
